import clsx from "clsx";
import React, { useState, useEffect, useRef } from "react";

import { CloseIcon, ForgotModalBanner } from "../../../assets/Icons";
import { IforgtPasswordModal } from "./ForgotPasswordModal";

const defaultAnimationClass = {
  beforeAnimation: "md:bottom-0",
  afterAnimation: "md:bottom-2/4",
};

const DELAY_BEFORE_TRNASITION_START = 10;
const TRNASITION_TIME = 500;

const ForgotPasswordModal: React.FunctionComponent<IforgtPasswordModal.IProps> = ({
  children,
  closeHandler,
  modalClass,
  maskClass,
  visible,
  maskClosable = true,
  mask = true,
  animation = true,
  animationClass = defaultAnimationClass,
  id,
}) => {
  const [animatingclass, setAnimatingClass] = useState(false);

  const modalRef = useRef<HTMLDivElement>(null);

  const handleClose = (event: React.MouseEvent) => {
    if (animation) {
      setAnimatingClass(false);
      setTimeout(() => closeHandler(event), TRNASITION_TIME);
    } else {
      setAnimatingClass(false);
      closeHandler(event);
    }
  };

  const defaultMaskClass = mask && "bg-black opacity-100";

  const onMaskClick = (event: React.MouseEvent) => {
    if (maskClosable) {
      if (modalRef?.current) {
        if (!modalRef || modalRef?.current.contains(event.target as HTMLElement)) {
          return;
        } else {
          handleClose(event);
        }
      }
    }
  };

  useEffect(() => {
    if (animation) {
      if (visible) {
        setTimeout(() => {
          setAnimatingClass(true);
        }, DELAY_BEFORE_TRNASITION_START);
      } else setAnimatingClass(false);
    }
  }, [visible]);

  const modalJSX = (
    <div
      onClick={onMaskClick}
      className={clsx(
        "top-0 left-0 w-full h-full fixed z-50 bg-opacity-40",
        defaultMaskClass,
        maskClass
      )}
    >
      <div
        id={id}
        ref={modalRef}
        className={clsx(
          "bottom-0 w-screen md:w-fit bg-white left-2/4  absolute -translate-x-1/2 md:translate-y-1/2  transition-[bottom]  duration-500",
          animatingclass
            ? animationClass?.afterAnimation
            : animation
            ? animationClass?.beforeAnimation
            : animationClass?.afterAnimation,
          modalClass
        )}
      >
        <div className="flex w-[970px] h-[577px] justify-between">
          <div className="">{children}</div>
          <div className="bg-[#14B1E7] w-[490px] p-6">
            <button className="float-right" onClick={handleClose}>
              <CloseIcon />
            </button>
            <div id="text" className="flex flex-col mt-10 ml-2">
              <span className="text-[26px] text-white font-semibold">Forgot your password?</span>
              <span className="mt-2 text-white">
                No problem. Reset your password by going through the steps.
              </span>
            </div>
            <div className="mt-10">
              <ForgotModalBanner />
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  return visible ? modalJSX : <></>;
};

export default ForgotPasswordModal;
